import type { ActionResult, FitnessConfig } from './types';

export async function loadConfig(): Promise<FitnessConfig> {
  if (import.meta.env.DEV) {
    return {
      ownerEmail: 'ops@caydenlasher.co',
      googleClientId: '', googlePickerApiKey: '', googleProjectNumber: '', driveRootFolderId: '', configured: false,
    };
  }
  const response = await fetch('/api/fitness/config', { credentials: 'same-origin' });
  if (!response.ok) throw new Error('Fitness configuration is unavailable.');
  return response.json() as Promise<FitnessConfig>;
}

export async function runAction<T>(action: string, input: Record<string, unknown> = {}): Promise<ActionResult<T>> {
  const response = await fetch('/api/fitness/action', {
    method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action, input, requestId: crypto.randomUUID() }),
  });
  const result = await response.json() as ActionResult<T>;
  if (!response.ok && !result.error) return { success: false, action, error: { code: 'request_failed', message: 'The request failed.' } };
  return result;
}
